import { Directive } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appTimeMask]'
})
export class TimeMaskDirective {

  constructor() { }

}
